function getAnalytics(type) {
  return sessionStorage.getItem(`analytics:${type}`);
}

export default getAnalytics;